<template>
  <main class="account-page">
    <div class="container account-page__inner">
      <button type="button" class="account-page__back" @click="goBack">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M5 12H19" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M13 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>بازگشت</span>
      </button>

      <header class="account-page__header">
        <p class="account-page__eyebrow">حساب کاربری</p>
        <h1 class="account-page__title">تنظیمات</h1>
        <p class="account-page__subtitle">ترجیحات خود را مدیریت کنید</p>
      </header>

      <section class="account-page__card">
        <div class="account-page__setting">
          <div>
            <h2 class="account-page__setting-title">اعلان‌ها</h2>
            <p class="account-page__setting-desc">درخواست دوستی، دعوت اسپیکینگ و پیام‌های داخل برنامه</p>
          </div>
          <div class="form-check form-switch">
            <input id="notifications" v-model="notifications" class="form-check-input" type="checkbox" />
          </div>
        </div>

        <div class="account-page__setting">
          <div>
            <h2 class="account-page__setting-title">زبان</h2>
            <p class="account-page__setting-desc">زبان نمایش برنامه</p>
          </div>
          <select v-model="language" class="form-select account-page__select">
            <option value="fa">فارسی</option>
            <option value="en">انگلیسی</option>
          </select>
        </div>
      </section>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import {
  notificationsEnabled,
  setNotificationsEnabled,
} from "@/composables/usePushNotifications";

const router = useRouter();
const notifications = ref(notificationsEnabled());
const language = ref("fa");

watch(notifications, async (enabled) => {
  const ok = await setNotificationsEnabled(enabled);
  if (enabled && !ok) notifications.value = false;
});

function goBack() {
  router.push("/dashboard");
}
</script>

<style scoped>
.account-page {
  --color-primary: #6D5EF8;
  --color-bg: #FCF9F6;
  --color-card: #FFFFFF;
  --color-border: #ECE4D9;
  --color-text: #4C372A;
  --color-muted: #8C8176;

  min-height: 100vh;
  background: var(--color-bg);
  color: var(--color-text);
  font-family: Vazirmatn, system-ui, "Segoe UI", Tahoma, sans-serif;
  padding: 56px 0;
  direction: rtl;
}

.account-page__inner {
  max-width: 640px;
}

.account-page__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--color-card);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  font-size: 14px;
  font-weight: 500;
  padding: 9px 18px;
  border-radius: 999px;
  cursor: pointer;
  margin-bottom: 32px;
  box-shadow: 0 2px 8px rgba(76, 55, 42, 0.06);
}

.account-page__back:hover {
  background: #f5f3ff;
  border-color: var(--color-primary);
}

.account-page__header {
  margin-bottom: 28px;
}

.account-page__eyebrow {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #6A4328;
}

.account-page__title {
  margin: 0 0 8px;
  font-size: 32px;
  font-weight: 700;
}

.account-page__subtitle {
  margin: 0;
  color: var(--color-muted);
}

.account-page__card {
  background: var(--color-card);
  border: 1px solid var(--color-border);
  border-radius: 18px;
  padding: 8px 24px;
  box-shadow: 0 8px 24px rgba(76, 55, 42, 0.06);
}

.account-page__setting {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 0;
  border-bottom: 1px solid var(--color-border);
}

.account-page__setting:last-child {
  border-bottom: none;
}

.account-page__setting-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
}

.account-page__setting-desc {
  margin: 0;
  font-size: 13px;
  color: var(--color-muted);
}

.account-page__select {
  max-width: 160px;
  border-color: var(--color-border);
}

.form-check-input:checked {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}
</style>
